export default __webpack_public_path__ + "static/media/volume.f3d58d26.svg";